import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

import Modal from '@fmbt/ui/Modal';
import Text from '@fmbt/ui/Text';
import { useLogOutButtonClick } from 'components/buttons/LogOutButton';
import { ENTERPRISE_NOT_FOUND_MESSAGE } from 'constants/enterprise';
import { goToEnterpriseList } from 'utils/URL/switch-enterprises';

type FetchFailureModalProps = {
  errorMessage: string;
};

/**
 * Enterprise / scaffold fetch failures shown from loading gates (offline, unknown enterprise, etc.).
 */
function FetchFailureModal({
  errorMessage
}: FetchFailureModalProps): JSX.Element {
  const { user: auth0User } = useAuth0();
  const handleLogOut = useLogOutButtonClick('Fetch Failure Modal');

  if (errorMessage === 'Network Error') {
    return (
      <Modal
        confirmText="Reload"
        hideDismissButton
        isOpen
        maskClosable={false}
        onConfirm={() => window.location.reload()}
        title="You seem to be offline"
      >
        <Text v="body">
          Sorry, we are unable to load the page due to poor reception. Please check your connectivity and try again
        </Text>
      </Modal>
    );
  }

  const showSwitchEnterprisesButton = errorMessage === ENTERPRISE_NOT_FOUND_MESSAGE;

  return (
    <Modal
      confirmText="Log Out"
      dismissText="Switch Enterprises"
      hideDismissButton={!showSwitchEnterprisesButton}
      isOpen
      maskClosable={false}
      onConfirm={handleLogOut}
      onDismiss={() => goToEnterpriseList(auth0User)}
      title="Sorry, something went wrong"
    >
      <Text v="body">{errorMessage}</Text>
    </Modal>
  );
}

export default FetchFailureModal;
